import { useModals } from "@/hooks/useModals";
import { lazy, Suspense } from "react";
import ModalSpinnerFallback from "@/ui/ModalSpinnerFallback";
const OnboardingModal = lazy(() => import("./OnboardingModal/OnboardingModal"));
const GrantApplicationSubmittedModal = lazy(() => import("./GrantApplicationSubmittedModal"));
const FarcasterQRCodeModal = lazy(() => import("./FarcasterQRCodeModal"));
const EditProfileModal = lazy(() => import("./EditProfileModal/EditProfileModal"));
const BuilderFormModal = lazy(() => import("./BuilderFormModal"));
const ReviewFeedbackModal = lazy(() => import("./ReviewFeedbackModal/ReviewFeedbackModal"));
const SubmitMilestoneModal = lazy(() => import("./SubmitMilestoneModal/SubmitMilestoneModal"));
const ConfirmationModal = lazy(() => import("./ConfirmationModal"));
const CustomizeReferralModal = lazy(() => import("./CustomizeReferralModal"));
const DocumensoSignModal = lazy(() => import("./DocumensoSignModal"));
const WalletVerifiedModal = lazy(() => import("./WalletVerifiedModal"));
const PaymentDetailsModal = lazy(() => import("./PaymentDetailsModal"));
const RejectionReasonModal = lazy(() => import("./RejectionReasonModal"));
const SetRewardAddressModal = lazy(() => import("./SetRewardAddressModal"));
const MyApplicationModal = lazy(() => import("./MyApplicationModal/MyApplicationModal"));
// NOTE: CustomizeReferralModal requires custom props and is not used generically by the modal system unless those props are provided.

interface ModalProps {
  closeModal: () => void;
  [key: string]: unknown;
}

export type ModalEntry = React.FC<ModalProps>;

const MODAL_CLASSES = {
  OnboardingModal,
  GrantApplicationSubmittedModal,
  FarcasterQRCodeModal,
  EditProfileModal,
  BuilderFormModal,
  ReviewFeedbackModal,
  SubmitMilestoneModal,
  ConfirmationModal,
  CustomizeReferralModal,
  DocumensoSignModal,
  WalletVerifiedModal,
  PaymentDetailsModal,
  RejectionReasonModal,
  SetRewardAddressModal,
  MyApplicationModal,
};

export type ModalNames = keyof typeof MODAL_CLASSES;

export default function ModalsRenderer() {
  const { list, closeModalByName } = useModals();

  const modalElements = list.map(({ modalName, ...modalProps }) => {
    const ModalKlass = MODAL_CLASSES[modalName];
    const closeModal = () => closeModalByName(modalName);

    return (
      <Suspense fallback={<ModalSpinnerFallback />} key={modalName}>
        <ModalKlass {...modalProps} closeModal={closeModal} />
      </Suspense>
    );
  });

  return modalElements;
}
